import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { withStyles } from "@material-ui/core/styles"
import MuiAccordion from "@material-ui/core/Accordion"
import MuiAccordionSummary from "@material-ui/core/AccordionSummary"
import MuiAccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { TiTick } from "@react-icons/all-files/ti/TiTick"
import { Link } from "gatsby"
import styled from "styled-components"
import { useDispatch } from "react-redux"
import { useAddUserPutMutation, useGetUserQuery } from "./features/api/authApi"
import { addDetails, addTopic } from "./features/authSlice"
import {
  getTopic,
  getDetails,
  saveDetails,
  saveNotes,
  saveTopic,
} from "../../utils/cart"

const Accordion = withStyles({
  root: {
    // borderBottom: "1.5px solid rgba(21, 21, 21, 0.22) !important",
    // background: "rgb(248, 248, 248, 0.4)",

    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles(() => ({
  root: {
    paddingBottom: "16px",
    paddingLeft: "16px",
  },
}))(MuiAccordionDetails)
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // background: "rgb(248, 248, 248, 0.4)",
    // boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.19)",
    borderRadius: "5px",
    // overflowX: "hidden",
    // overflowY: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}))

function CourseSection(props) {
  let {
    data,
    handleSubmit,
    subTopicStrapiId,
    module_id,
    keyId,
    module_title,
    short_dec,
    uri,
    category,
    slug,
    course_image,
    mainModule_id,
    orderKey,
    courseLength,
    title,
  } = props

  let topic = getTopic()

  let details = getDetails() 

  // let topic = {}
  // let details = {}
  const dispatch = useDispatch()
  const { data: userProfile, isLoading: userProfileLoading } = useGetUserQuery()

  const [addUserPut, { isLoading, error }] = useAddUserPutMutation()

  const [activeLi, setActiveLi] = React.useState("")

  const lengthCheck = Object.keys(details).filter(
    (key) => details[key].checked === true && details[key].keyId === keyId
  ).length

  const sectionId = topic[keyId]?.section_id || 0
  const [expanded, setExpanded] = React.useState(data[sectionId]?.section_title)
  const classes = useStyles()

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const handleCheckboxChange = async (e, l, d) => {
    e.preventDefault()
    const key_id = l.id
    let elementList = {
      [key_id]: {
        section_id: l.id,
        checked: true,
        module_ids: mainModule_id,
        mainSection_id: d.id,
        keyId: keyId,
      },
    }
    try {
      let copy = { ...details }
      const index = copy[key_id]?.section_id !== l.id
      if (index) {
        Object.assign(copy, elementList)
      } else {
        copy[key_id].checked = !copy[key_id].checked
      }
      const credentials = { topicDetails: copy }
      const kId = userProfile.length  && userProfile[0].id
      dispatch(addDetails({ copy }))
      await addUserPut({ credentials, kId })
    } catch (e) {
      console.log(e)
    }
  }

  //
  // const saveToLocalStorage = () => {
  //   userProfile && (
  //     <>
  //       {saveTopic(userProfile[0]?.userLastWatched)}
  //       {saveDetails(userProfile[0]?.topicDetails)}
  //       {saveNotes(userProfile[0]?.userNotes)}
  //     </>
  //   )
  // }

  const handleClick = async (e, i, id, l) => {
    setActiveLi(e.target.innerHTML)

    let elementList = {
      [keyId]: {
        module_ids: module_id,
        section_id: i,
        insideSection_id: id,
        keyId: keyId,
        title: l.title,
        module: module_title,
        overview: short_dec,
        uri: uri,
        slug: slug,
        dId: orderKey,
        img: course_image,
        type: l.type,
        category: category,
        courseFinishedLength: lengthCheck,
        courseLength: courseLength.length,
        title: title,
      },
    }
    try {
      let copy = { ...topic }
      const index = copy[keyId]?.keyId !== keyId
      console.log(index)
      if (index) {
        Object.assign(copy, elementList)
      } else {
        copy[keyId].module_ids = module_id
        copy[keyId].section_id = i
        copy[keyId].insideSection_id = id
        copy[keyId].keyId = keyId
        copy[keyId].module = module_title
        copy[keyId].title = l.title
        copy[keyId].overview = short_dec
        copy[keyId].uri = uri
        copy[keyId].slug = slug
        copy[keyId].dId = orderKey
        copy[keyId].img = course_image
        copy[keyId].type = l.type
        copy[keyId].courseFinishedLength = lengthCheck
        copy[keyId].category = category
        copy[keyId].mainTitle = title
      }

      const credentials = { userLastWatched: copy }
      // saveToLocalStorage()

      const kId = userProfile.length && userProfile[0].id
      dispatch(addTopic({ copy }))
      await addUserPut({ credentials, kId })
    } catch (e) {
      console.log(e)
    }
  }

 

  return (
    <Wrapper>
      <div className={classes.root}>
        {data &&
          topic &&
          details &&
          data.map((d, i) => {
            return (
              <Accordion square>
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    className="accordion_title"
                  >
                    <Typography key={d.id} className="section_title">
                      {d.section_title}
                    </Typography>
                    <span style={{ fontSize: "0.8rem" }}>
                      {`  
                      ${
                        Object.keys(details).filter(
                          (key) =>
                            details[key].mainSection_id === d.id &&
                            details[key].checked === true
                        ).length
                      } / ${d.sections?.length}`}
                    </span>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {d.sections.map((l, id) => {
                      return (
                        <div
                          className={
                            activeLi === l.title
                              ? "lessons_panel_active"
                              : topic[keyId]?.title === l.title
                              ? "lessons_panel_active"
                              : "lessons_panel"
                          }
                          key={l.id}
                        >
                          <div className="section-title">
                            <ul
                              onClick={(e) => handleClick(e, i, id, l)}
                              key={l.id}
                              style={{ cursor: "pointer" }}
                            >
                              <li key={l.id}>{l.title}</li>
                            </ul>
                            {l.link_to.includes("/") && (
                              <div>
                                <Link to={l.link_to}>Resources</Link>
                              </div>
                            )}
                          </div>

                          <div className="checkbox">
                            <label>
                              <input
                                type="checkbox"
                                id={id}
                                name={l.title}
                                onClick={(e) => handleCheckboxChange(e, l, d)}
                                value={l.title}
                                checked={details && details[l.id]?.checked}
                                disabled={
                                  topic && topic[keyId]?.title != l.title
                                }
                              />
                              {details[l.id]?.checked && <TiTick />}
                            </label>
                          </div>
                        </div>
                      )
                    })}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )
          })}
        {/* <div>
        {details?.map((s) => s.map((l) => <span>{l[0].id}</span>))}
      </div> */}
      </div>
    </Wrapper>
  )
}

export default CourseSection

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  .MuiPaper-elevation1 {
    box-shadow: none;
  }
  .checkbox {
    margin-right: 1rem;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
  .MuiAccordionSummary-root {
    background-color: #d9d9d9 !important;
    padding-left: 2rem !important;
    border-bottom: 1px solid rgba(21, 21, 21, 0.22);
    border-top: 1px solid rgba(21, 21, 21, 0.22);
  }
  .MuiAccordionDetails-root {
    padding: 0 !important;
  }
  .lessons_panel {
    transition: 0.2s ease-in-out;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    &:hover {
      background-color: #f7f8f8 !important;
    }
  }
  .section-title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    a {
      font-size: 0.7rem;
      text-decoration: none;
      background: var(--secondaryColor);
      padding: 10px 15px;
      color: #fff;
      margin-right: 0.5rem;
      margin-left: 0.5rem;
      border-radius: 6px;
    }
  }
  ul {
    display: flex;
    width: 100%;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    li {
      list-style: none;
      padding-left: 2rem;
      padding-right: 1rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      color: #151515;
      font-size: 0.9rem;
    }
  }
  .subtopic_li {
    width: 100%;
    list-style: none;
    font-size: 16px;
    font-family: var(--family);
    padding: 10px 0;
    font-weight: 500;
    color: #151515;
    opacity: 1 !important;
    transition: 0.3s ease-in-out;
  }
  .lessons_panel_active {
    /* or 131% */
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    color: #151515;
    opacity: 1;
    background-color: #f7f8f8 !important;
  }
  .section_title {
    font-weight: 600 !important;
    text-transform: capitalize;
    @media (max-width: 767px) {
      font-size: 1rem !important;
    }
  }
`
